import { StackItem, Split, SplitItem, TextContent, Text, Alert, Stack } from '@patternfly/react-core';
import React from 'react';
import { BackendValidationErrorViewModel } from '../../store/global-types/store-errors';
import { useTranslation } from 'react-i18next';
import { getModelTypeStyle, ModelType } from '../../store/global-types/customization-types';


interface ModelSelectionRuleWrapperProps {
    title: string,
    modelType: ModelType,
    isModified: boolean,
    hasValidationError: boolean,
    className?: string,
    validationError: BackendValidationErrorViewModel | undefined,
    testId?: string,
}

const ModelSelectionRuleWrapper = (props: React.PropsWithChildren<ModelSelectionRuleWrapperProps>) => {
    const { t } = useTranslation();
    
    const { title, modelType, isModified, hasValidationError, validationError, children, className, testId } = props;

    const style = `model-selection-rule ${getModelTypeStyle(modelType)}`;

    return (
        <StackItem className={`selection-rule-wrapper ${className || ''} ${hasValidationError ? 'validation-error' : ''}`}>
            <div className={style} data-testid={testId || undefined}>
                <Stack>
                    <StackItem>
                        <Split>
                            <SplitItem className="rule-type">
                                <TextContent>
                                    <Text>{title}{`${isModified ? '*' : ''}`}</Text>
                                </TextContent>
                            </SplitItem>
                            <SplitItem isFilled className="rule-settings">
                                {children}
                            </SplitItem>
                        </Split>
                    </StackItem>
                    {
                        hasValidationError && validationError && (
                            <StackItem className="selection-rule-wrapper validation-error validation-error-box selectable">
                                <Alert variant="danger" isInline isPlain isExpandable title={t('common.validationError.message', { error: validationError.message })}>
                                    <div>Error type: {validationError.detail}</div>
                                    <div>Error ctx: {validationError.ctx}</div>
                                </Alert>
                            </StackItem>
                        )
                    }
                </Stack>
            </div>
        </StackItem>

    );
}

export default ModelSelectionRuleWrapper;
